/*
  NGM-180. Every Segment call made once the variant is known carries the experiment in its
  context, so it lands on the tracks table as context_experiment_name / context_experiment_variant
  and can be joined to the SendGrid data in Metabase. That includes the control arm.

  The variant is held here rather than read through a hook inside useCausesPortalAnalytics,
  because that hook has ~50 callers and every flag read sends $feature_flag_called. One component
  resolves the flag (useGfmExperimentExposure) and writes it here; everything else reads it.
*/
import { GOFUNDME_USER_JOURNEYS_VARIANTS } from '@percent/cause-dashboard/constants/gofundmeUserJourneys'

export const GFM_EXPERIMENT_NAME = 'gofundme_user_journeys_ab_test'

export const GFM_EXPERIMENT_EVENTS = {
  exposed: 'Experiment Exposed'
} as const

const GFM_EXPERIMENT_VARIANTS = ['control', ...GOFUNDME_USER_JOURNEYS_VARIANTS] as const

export type GfmExperimentVariant = typeof GFM_EXPERIMENT_VARIANTS[number]

// PostHog hands back string | boolean | undefined; the ticket requires strings, never booleans
const isGfmExperimentVariant = (value: unknown): value is GfmExperimentVariant =>
  (GFM_EXPERIMENT_VARIANTS as readonly unknown[]).includes(value)

export const toGfmExperimentVariant = (value: unknown): GfmExperimentVariant | null =>
  isGfmExperimentVariant(value) ? value : null

let currentVariant: GfmExperimentVariant | null = null

export const setGfmExperimentVariant = (variant: GfmExperimentVariant | null) => {
  currentVariant = variant
}

export type GfmExperimentContext = {
  experiment?: { name: string; variant: GfmExperimentVariant }
}

// Empty until the variant resolves, so events fired before then carry no experiment at all
// rather than a wrong one.
export const getGfmExperimentContext = (): GfmExperimentContext =>
  currentVariant ? { experiment: { name: GFM_EXPERIMENT_NAME, variant: currentVariant } } : {}
